export const userListRoutes = {
  path: 'member-list',
  name: 'MemberList',
  component: () => import('@/views/member/memberList/index.vue'),
  meta: {
    hidden: false,
    title: 'User List',
    activeMenu:'/member'
  }
}

export const userDetailRoutes = {
  path: 'detail',
  name: 'MemberDetail',
  component: () => import('@/views/member/memberDetail/index.vue'),
  meta: {
    hidden: false,
    title: 'User Detail',
    activeMenu:'/member'
  }
}

export const userModifyRoutes = {
  path: 'modify',
  name: 'MemberModify',
  component: () => import('@/views/member/memberModify/index.vue'),
  meta: {
    hidden: false,
    title: 'User Modify',
    activeMenu:'/member'
  }
}


